import React from 'react';

const LazyGraph = React.lazy(() => import('./Graph'));

export default LazyGraph;
